import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { getGetConfigQueryOptions } from '@/api/generated/endpoints';
import { RouteErrorFallback } from '@/components/route-error-fallback';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { sessionQueryOptions } from '@/features/auth';
import { EditSettingsForm } from '@/features/settings/components/edit-settings-form';

export const Route = createFileRoute('/_authenticated/settings')({
	loader: ({ context: { queryClient } }) => {
		void queryClient.ensureQueryData(getGetConfigQueryOptions());
	},
	errorComponent: (props) => <RouteErrorFallback {...props} fallbackMessageKey='settings_error_load' />,
	component: SettingsRoute,
});

function SettingsRoute() {
	const { t } = useTranslation();
	// Ensured by the _authenticated layout's beforeLoad — resolves from cache.
	const { data: session } = useSuspenseQuery(sessionQueryOptions);
	const readOnly = session.user.role !== 'admin';

	return (
		<Card>
			<CardHeader>
				<CardTitle>{t('settings_title')}</CardTitle>
				<CardDescription>{t('settings_description')}</CardDescription>
			</CardHeader>

			<CardContent>
				<EditSettingsForm readOnly={readOnly} />
			</CardContent>
		</Card>
	);
}
